import { IProject } from 'src/types/projects';

/**
 * Returns whether the current user may act on the given project in the client dashboard.
 * `projectId` null means no project is selected (allowed to view pages that prompt for a project).
 */
export function userHasAccessToProject(
    projectId: string | null,
    projects: IProject[]
): boolean {
    if (!projectId) {
        return true;
    }
    return projects.some((p) => p.id === projectId);
}
